class DeliveryInformation extends HTMLElement {
  constructor() {
    super();
    this.selectedStore = JSON.parse(
      localStorage.getItem("selectedStoreDetails")
    );

    this.deliveryProfiles = JSON.parse(
      localStorage.getItem("deliveryProfiles")
    );
    this.closestStoreDistance = localStorage.getItem("closestStoreDistance");
    if (!this.selectedStore || !this.deliveryProfiles) return;
    if(this.selectedStore.erpStoreId == "225"){
      this.textContent = `Delivery within 2 - 3 days`
    }
    else{
      this.textContent = findFastestDeliveryMethod(
        this.selectedStore,
        this.deliveryProfiles,
        this.closestStoreDistance
      );
    }
  }
}
customElements.define("delivery-information", DeliveryInformation);

function findFastestDeliveryMethod(storeData, deliveryMethods, distance = 10) {
  let fastestMethod = deliveryMethods.reduce((min, current) => {
    if (
      parseInt(current.minDistance) <= distance &&
      distance <= parseInt(current.maxDistance) &&
      parseInt(current.time) < parseInt(min.time)
    ) {
      return current;
    }
    return min;
  }, deliveryMethods[0]);
  let dayOfWeek = getNextAvailableDay(storeData, getDayOfWeek());

  let localDeliveryTime =
    storeData.localDelivery[dayOfWeek.day].timeSlots[0]?.end;

  let currentTime = getCurrentTime();
  
  let difference = timeDiffInMinutes(currentTime, localDeliveryTime);

  if (difference <= 0) {
    dayOfWeek = getNextAvailableDay(storeData, dayOfWeek.day);

    localDeliveryTime = storeData.localDelivery[dayOfWeek.day].timeSlots[0]?.end;
  }

  let totalDeliveryTime;

  let deliveryTimeMessage;

  if (fastestMethod.time.includes("days")) {
    totalDeliveryTime = parseInt(fastestMethod.time) * 24 * 60;
  } else if (fastestMethod.time.includes("hours")) {
    totalDeliveryTime = parseInt(fastestMethod.time) * 60;
  } else {
    totalDeliveryTime = parseInt(fastestMethod.time);
  }
  if (
    difference > 0 &&
    dayOfWeek.daysCount == 0 &&
    parseFloat(fastestMethod.maxDistance) >= parseFloat(distance)
  ) {
    deliveryTimeMessage = `Delivery within ${Math.floor(
      totalDeliveryTime / 60
    )} - ${Math.ceil(totalDeliveryTime / 60)} hours`;
  } else if (
    parseFloat(fastestMethod.maxDistance) >= parseFloat(distance) &&
    ((difference > 0 && dayOfWeek.daysCount == 1) ||
      (difference <= 0 && dayOfWeek.daysCount == 0))
  ) {
    deliveryTimeMessage = `Delivery within 1 day`;
  } else {
    if (dayOfWeek.daysCount < 1) {
      dayOfWeek.daysCount = 2;
    }
    deliveryTimeMessage = `Delivery within ${dayOfWeek.daysCount - 1} - ${
      dayOfWeek.daysCount
    } days`;
  }

  return deliveryTimeMessage;
}
function timeDiffInMinutes(time1, time2) {
  const time1Minutes =
    parseInt(time1.split(":")[0]) * 60 + parseInt(time1.split(":")[1]);

  const time2Minutes =
    parseInt(time2.split(":")[0]) * 60 + parseInt(time2.split(":")[1]);

  const diffMinutes = time2Minutes - time1Minutes;

  return diffMinutes;
}
function getDayOfWeek() {
  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  let today = new Date();
  return days[today.getDay()];
}

function getCurrentTime() {
  let today = new Date();
  return today.toLocaleTimeString().substring(0, 5);
}

function getNextAvailableDay(storeData, currentDay) {
  // let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  // let currentIndex = days.indexOf(currentDay);
  // let nextIndex = currentIndex % 7;
  // let count = 0;
  // let nextDay = days[nextIndex];
  // while (
  //   !storeData.localDelivery[nextDay] ||
  //   !storeData.localDelivery[nextDay].isOpen
  // ) {
  //   nextIndex = (nextIndex + 1) % 7;
  //   nextDay = days[nextIndex];
  //   count = count + 1;
  // }
  // return { day: nextDay, daysCount: count };
  let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
let currentIndex = days.indexOf(currentDay);
let nextIndex = currentIndex;
let count = 0;
let nextDay = "";

for (let i = 0; i < 7; i++) {
  nextIndex = (currentIndex + i) % 7;
  nextDay = days[nextIndex];

  if (storeData.localDelivery[nextDay] && storeData.localDelivery[nextDay].isOpen) {
    count = i;
    break;
  }
}

return { day: nextDay, daysCount: count };
}
